__turbopack_context__.v({
  "root": "ToggleAnimationSection-module__Vf0rzq__root",
  "sticky": "ToggleAnimationSection-module__Vf0rzq__sticky",
  "textContainer": "ToggleAnimationSection-module__Vf0rzq__textContainer",
});
